<script lang="ts" setup>
import { usePreviewImg } from "@/use/common";
import { useGlobalUser } from "@/stores/globalUser";
import { ref } from "vue";
import { ContentRatingEnum } from "@/enums";
import { Media, Reply } from "@/types/entity";

// Props & Emit
const props = withDefaults(
  defineProps<{
    // 1. 基础数据
    media: Media;
    isNsfw?: ContentRatingEnum;
    // 2. 卡片上的组件
    // 2.1 ReactionCounter
    reply?: Reply;
    reactionTopN?: number;
    // 3. 交互效果
    enableHoverScale?: boolean;
    enableBlurToggleBtn?: boolean;
    blur?: "blur" | "blur-lg" | "blur-xl" | "blur-2xl";
    enableAnimation?: boolean;
    alt?: string;
  }>(),
  {
    reactionTopN: 3,
    enableHoverScale: true,
    enableBlurToggleBtn: true,
    blur: "blur-xl",
    enableAnimation: true,
  }
);

// States
const userStore = useGlobalUser();

const showNsfwBlur = ref(!!userStore.user?.isNsfwBlurry);
</script>
<template>
  <div
    :class="{
      [`aspect-[${(media?.width && media!.width > media!.height!) ? '16/9' : '3/4'}]`]: true,
      'transition-all duration-300': enableAnimation
    }"
    class="overflow-hidden cursor-pointer bg-base-200 relative"
  >
    <!-- <div class="z-10 absolute inset-0 bg-edge-darken-b image-card-filter" /> -->
    <VanImage
      :alt="alt"
      :class="{
        'image-card-scale': enableHoverScale,
        [blur]: isNsfw && showNsfwBlur,
        'transition-all duration-300': enableAnimation,
      }"
      :src="media?.url"
      class="w-full h-full block"
      fit="cover"
      crossorigin="anonymous"
    />
    <!-- LR Corner -->
    <div v-if="isNsfw" class="absolute top-1 right-1 flex z-20">
      <div class="text-xs p-1 rounded bg-black/50 text-white">
        {{ $t("nsfw.nsfw") }}
      </div>
    </div>
    <!-- LB Corner -->
    <div
      class="absolute bottom-1 left-1 flex rounded bg-neutral/50 z-20 text-xs"
    >
      <reaction-counter v-if="reply" :reply="reply" :top-n="3" ghost group />
    </div>
    <!-- RB Corner -->
    <div
      v-if="isNsfw && enableBlurToggleBtn"
      class="absolute bottom-1 right-1 z-20"
    >
      <button
        class="btn btn-sm btn-square btn-ghost text-white"
        @click.stop="showNsfwBlur = !showNsfwBlur"
      >
        <i v-if="showNsfwBlur" class="iconify mdi--eye-outline" />
        <i v-else class="iconify mdi--eye-off-outline" />
      </button>
    </div>
  </div>
</template>
<style scoped>
.bg-edge-darken-y {
  background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.16) 10px,
      transparent 100px
    ),
    linear-gradient(to top, rgba(0, 0, 0, 0.16) 10px, transparent 100px);
}

.bg-edge-darken-b {
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.2) 10px,
    transparent 100px
  );
}

.bg-edge-darken-t {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.2) 10px,
    transparent 100px
  );
}

.image-card-filter:hover + .image-card-scale {
  @apply scale-105;
}
</style>
